import React, { useEffect, useState } from "react";
import s from "./MasivosSalpren.module.css";
//assets
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import masiveDistributionServices from "../../../../api/delivery/masiveDistribution";
import Pager from "../../../Shared/Pagination/Pagination";
import { dateFormats } from "../../../../helpers/convertDate";
import LoopIcon from '@mui/icons-material/Loop';
import IconButton from "@mui/material/IconButton";
//materialUi
import Brightness1Icon from '@mui/icons-material/Brightness1';
import Grid from "@mui/material/Grid"
import Button from "@mui/material/Button"
import Tooltip from "@mui/material/Tooltip"
import CircularProgress from "@mui/material/CircularProgress"
import TableContainer from "@mui/material/TableContainer"
import Table from "@mui/material/Table"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableCell from "@mui/material/TableCell"
import TableBody from "@mui/material/TableBody"
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import UploadRoundedIcon from "@mui/icons-material/UploadRounded";
import UploadModal from "./UploadModal";
import DetailSalpren from "./Detail";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import Swal from "sweetalert2";
import useTranslationException from "../../../../helpers/exceptions";
import ConciliationModal from "./ConciliationModal/index";
const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: ".9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

// ========================== | MASIVOS SALPREN | ==============================

const MasivosSalpren = () => {
  const dates = dateFormats();
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const { textColor } = useSelector((state) => state.local);

  //Estados
  const [open, setOpen] = useState(false);
  const [detail, setDetail] = useState({
    status: false,
    data: {},
  });
  const [items, setItems] = useState([]);
  const [loadingDelete, setLoadingDelete] = useState({
    id: 0,
    status: false,
  });

  //Paginado
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);
  const [sort, setSort] = useState({
    criteria: "DESC",
    field: "processedDate",
  });

  const [conciliationModalData, setConciliationModalData] = useState({
    open: false,
    data: undefined
  })

  const getFiles = () => {
    setLoading(true);
    masiveDistributionServices
      .getAllSalprem(page, pageSize, sort)
      .then((res) => {
        setItems(res.content);
        setTotalPages(res.totalPages);
      })
      .then(() => setLoading(false))
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setLoading(false);
      });
  };

  const handleDetail = (item) => {
    setDetail({
      status: true,
      data: item,
    });
  };

  const handleDelete = (item) => {
    setLoadingDelete({
      id: item.id,
      status: true,
    });
    Swal.fire({
      title: `${t("deleteFile")}: ${item.fileName}`,
      text: `${t("deleteTarascaText")}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00A36C",
      cancelButtonColor: "#d33",
      confirmButtonText: t("confirm"),
      cancelButtonText: t("cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        masiveDistributionServices
          .deleteSalpremFile(item?.id)
          .then(() => {
            Swal.fire(
              t("successDeleteTarascaTitle"),
              t("successDeleteTarascaText"),
              "success",
            ).then(() => {
              getFiles();
              setLoadingDelete({
                id: 0,
                status: false,
              });
            });
          })
          .catch((e) => {
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              t("anErrorOccurred,TryAgain"),
              t("retry"),
            );
            setLoadingDelete({
              id: 0,
              status: false,
            });
          });
      } else {
        setLoadingDelete({
          id: 0,
          status: false,
        });
      }
    });
  };

  const handleSort = (name) => {
    setSort((prev) => ({
      criteria:
        prev.field === name
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: name,
    }));
  };

  useEffect(() => {
    getFiles();
  }, [page, pageSize, sort]);

  const handleConcilitation = (id) => {
    masiveDistributionServices
      .putPremConciliation(id)
      .then((response) => {
        const {
          fileConciliated,
          errorItem,
        } = response

        if (!fileConciliated) {
          setConciliationModalData({ conciliationData: errorItem, open: true })
        }
      }).catch(() => {
        Swal.fire(t("retry"), t("sorryErrorOcurred"), "error")
      });
  }

  return (
    <Grid container className={s.container}>
      {detail.status ? (
        <DetailSalpren detail={detail} setDetail={setDetail} />
      ) : (
        <>
          <Grid item container xs={11} className={s.header}>
            <Grid item xs={12} lg={5} md={8} className={s.titleContainer}>
              <EmojiEventsIcon
                sx={{ fontSize: "2rem", color: "primary.main" }}
              />
              <h4>{t("salprem")}</h4>
            </Grid>
            <Grid item xs={12} lg={2} md={3}>
              <Tooltip placement="top" title={t("uploadFile")}>
                <Button
                  variant="contained"
                  className={s.uploadBtn}
                  onClick={() => setOpen(true)}
                >
                  <UploadRoundedIcon sx={{ fontSize: "2rem" }} />
                </Button>
              </Tooltip>
            </Grid>
          </Grid>

          {loading ? (
            <Grid item xs={11} className={s.loader}>
              <CircularProgress size={"4rem"} />
            </Grid>
          ) : items?.length ? (
            <Grid item container xs={11} className={s.data}>
              <TableContainer className={s.tableContainer}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("processedFile")}
                      >{`${t("archive")} ${sort.field === "processedFile" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("raffleNumber")}
                      >{`${t("drawNumber")} ${sort.field === "raffleNumber" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          "&:hover": { cursor: "pointer" },
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                        onClick={() => handleSort("processedDate")}
                      >{`${t("ProcessDate")} ${sort.field === "processedDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}</TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        Estado Conciliación
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                          fontSize: ".9rem",
                          fontWeight: 500,
                          fontFamily: "Roboto, sans-Serif",
                        }}
                      >
                        Acciones
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items.map((item, i) => {
                      return (
                        <React.Fragment key={item.id}>
                          <TableRow
                            sx={{
                              "&:hover": { backgroundColor: "secondary.light" },
                            }}
                          >
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                              onClick={() => handleDetail(item)}
                            >
                              {item.fileName || "-"}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                              onClick={() => handleDetail(item)}
                            >
                              {item.raffle.number || "-"}
                            </TableCell>
                            <TableCell
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                              onClick={() => handleDetail(item)}
                            >
                              {dates.formatDate(item.processDate)}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              {item.conciliation ?
                                <Brightness1Icon fontSize="small" color="success" /> :
                                <Brightness1Icon fontSize="small" color="error" />}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                ...cellStyles,
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                                alignItems: "center",
                                justifyContent: "center",
                                display: "flex"
                              }}
                            >
                              {loadingDelete.status &&
                                loadingDelete.id === item.id ? (
                                <CircularProgress size={"2rem"} />
                              ) : (
                                <DeleteForeverRoundedIcon
                                  className={s.iconbtn}
                                  sx={{ color: "primary.dark" }}
                                  onClick={() => handleDelete(item)}
                                />
                              )}

                              {!item.conciliation &&
                                <IconButton
                                  onClick={() => handleConcilitation(item.id)}
                                  color="primary"
                                  aria-label="Reconciliar"
                                >
                                  <LoopIcon
                                    className={s.iconbtn}
                                  />
                                </IconButton>
                              }
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          ) : (
            <Grid item xs={12} className={s.noResults}>
              {t("noResults")}
            </Grid>
          )}
          <UploadModal
            open={open}
            setOpen={setOpen}
            getFiles={getFiles}
            setConciliationModal={setConciliationModalData}
          />
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: "50px",
            }}
          >
            <Pager
              pageSize={pageSize}
              setPageSize={setPageSize}
              page={page}
              setPage={setPage}
              totalPages={totalPages}
              pageCustom={pageCustom}
              setPageCustom={setPageCustom}
            />
          </Grid>
        </>
      )}
      {conciliationModalData.open &&
        <ConciliationModal
          data={conciliationModalData}
          setData={setConciliationModalData}
        />
      }
    </Grid>
  );
};

export default MasivosSalpren;
